var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-item',{attrs:{"id":"idBanco","track-by":"id_banco","value":_vm.value,"custom-label":(option) => `${option.id_banco} - ${option.nombre}`,"placeholder":"Seleccione un banco","options":_vm.bancosOptions,"loading":_vm.isLoading},on:{"input":($event) => _vm.$emit('input', $event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }